const HIDE_DETAIL = 'CARD_DETAILS_HIDE';

class cardDetailsController {
  constructor($log, $scope) {
    'ngInject';
    this.log = $log;
    this.open = false;

    $scope.$on(HIDE_DETAIL,()=>{
      this.open = false;
    });
  }

  isOpen() {
    return this.open === true;
  }

  toggle() {
    this.open = !this.open;
    this.log.info('detail toggle(): isOpen', this.open);
  }

  getCardClass() {
    return this.headerClass;
  }

  getContentClass() {
    return {
      'is-open': this.isOpen()
    };
  }
}

export default cardDetailsController;



// WEBPACK FOOTER //
// ./client/app/components/cardDetails/cardDetails.controller.js